import { FeedTitleDropdown } from './components';
import { useFeedPanelProps } from './hooks/useFeedPanelProps';
import { RecentEventsFeed } from './RecentEventsFeed';
import { AlertsFeed } from './AlertsFeed';
import { DatabaseEventsFeed } from './DatabaseEventsFeed';
import { AlertRuleFeed } from './AlertRuleFeed';
import { RelatedEventFeed } from './RelatedEventFeed';
import { VehicleEventFeed } from './VehicleEventFeed';
import { PersonEventFeed } from './PersonEventFeed';
import { QueryResultsFeed } from './QueryResultsFeed';
import { ReportEventsFeed } from './ReportEventsFeed';
import { SourceEventsFeed } from './SourceEventsFeed';
import { SourceAlertsFeed } from './SourceAlertsFeed';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';

export const ALERT_FEED_TYPES = [
    'recentAlerts',
    'alerts',
    'sourceAlerts',
    'alertRule',
];

export function EventFeedPanel() {
    const {
        context,
        hasSwitchableOptions,
        options,
        switchFeedContext,
        emptyState,
    } = useFeedPanelProps();
    const { alertsEnabled } = useFeatureFlags();

    if (!context) return null;
    if (!alertsEnabled && ALERT_FEED_TYPES.includes(context.type)) return null;

    const titleContent = hasSwitchableOptions ? (
        <FeedTitleDropdown options={options} onChange={switchFeedContext} />
    ) : undefined;

    switch (context.type) {
        case 'recentAlerts':
        case 'alerts':
            return (
                <AlertsFeed
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'recentEvents':
            return (
                <RecentEventsFeed
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'databaseEvents':
            return (
                <DatabaseEventsFeed
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'sourceDatabaseEvents':
            return (
                <DatabaseEventsFeed
                    sourceId={context.sourceId}
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'sourceEvents':
            return (
                <SourceEventsFeed
                    sourceId={context.sourceId}
                    pageKey={context.pageKey}
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'sourceAlerts':
            return (
                <SourceAlertsFeed
                    sourceId={context.sourceId}
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'alertRule':
            return (
                <AlertRuleFeed
                    alertRuleId={context.alertRuleId}
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'relatedEvent':
            return (
                <RelatedEventFeed
                    eventId={context.eventId}
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'vehicle':
            return (
                <VehicleEventFeed
                    vehicleId={context.vehicleId}
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'person':
            return (
                <PersonEventFeed
                    personId={context.personId}
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'queryResults':
            return (
                <QueryResultsFeed
                    eventId={context.eventId}
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
        case 'reportEvents':
            return (
                <ReportEventsFeed
                    reportId={context.reportId}
                    titleContent={titleContent}
                    emptyState={emptyState}
                />
            );
    }
}
